<template>
  <div id="app-contain">
    <header id="header" :class="isShow ? 'header-bg' : ''">
      <div class="header-content">
        <div class="logo-container">
          <img src="../src/assets/logo.jpg">
          <div>CafeDrama</div>
        </div>
        <nav>
          <a href="#" class="active">Home</a>
          <a href="#products" class="">Products</a>
          <a href="#about" class="">About Us</a>
          <a href="#contact">Contact Us</a>
        </nav>
      </div>
    </header>
    <div class="top-section" id="top-banner">
      <!-- <img src="../src/assets/img_slogan.png" class="animate__animated animate__backInDown"> -->
       <div class="animate__animated animate__backInDown">Relax anytime,anywhere at CafeDrama</div>
    </div>
    <main>
      <div id="products">
        <section>
          <div class="section-content odd">
            <p class="bg-text product1">PRODUCTS</p>
            <div class="content-left" id="product1-left">
              <div class="screenshot-box">
                <div class="screenshot-b">
                  <img src="../src/assets/img_screenshot_rich.png" alt="Embark on a Journey of Discovery" class="screenshot">
                </div>
                </div>
            </div>
            <div class="hide" id="product1-right">
              <h2 class="content-title">Embark on a Journey of Discovery</h2>
              <p class="content-subtitle">Riveting Short Dramas Await Your Exploration</p>
            </div>
          </div>
        </section>
  
        <section>
          <div class="section-content odd">
            <p class="bg-text product2">PRODUCTS</p>
            <div class="hide" id="product2-left">
              <h2 class="content-title">Curated Dramas in HD</h2>
              <p class="content-subtitle">Engaging High-Definition Short Dramas Tailored to Your Interests</p>
            </div>
            <div class="hide" id="product2-right">
              <div class="screenshot-box">
                <div class="screenshot-b">
                  <img src="../src/assets/img_screenshot_recommende.png" class="screenshot">
                </div>
                  </div>
            </div>
          </div>
        </section>
  
        <section>
          <div class="section-content even">
            <p class="bg-text product3">PRODUCTS</p>
            <div class="hide" id="product3-left">
              <div class="screenshot-box">
                <div class="screenshot-b">
                  <img src="../src/assets/img_screenshot_updating.png" class="screenshot">
                </div>
                 </div>
            </div>
            <div class="hide" id="product3-right">
              <h2 class="content-title">New Dramas Every Day</h2>
              <p class="content-subtitle">Don't Miss a Moment of Brilliance.</p>
            </div>
          </div>
        </section>
      </div>
      

      <section id="about">
        <div class="section-content about">
          <p class="bg-text about-us">ABOUT US</p>
          <h2>
            SHANGHAI SHAOZHEN TECHNOLOGY CO., LTD.
          </h2>
          <div class="about-img"></div>
          <p class="introduce">
            SHANGHAI SHAOZHEN TECHNOLOGY CO., LTD. is an innovative leader in the short drama production industry, offering a full suite of services from concept to execution. Established in Shanghai, China, with an additional joint venture in Guangzhou, the company has been at the forefront of transforming the short drama landscape since its founding in March 2022. Driven by a passion for creativity and a deep understanding of the evolving digital media landscape, Shanghai Shaozhen specializes in producing captivating short-form content that resonates with diverse audiences. The company has quickly emerged as a trailblazer in the industry, leveraging cutting-edge technology and a strong network of creative talent to push the boundaries of storytelling. Whether through original series, collaborations, or branded content, Shanghai Shaozhen is committed to shaping the future of entertainment with bold, engaging, and thought-provoking narratives.
          </p>
        </div>
      </section>

      <section>
        <div class="section-content mission">
          <div class="mission-title">
            <p class="bg-text">MISSION</p>
            <div class="mission-img"></div>
          </div>
          <p class="mission-text">
            CREATING QUALITY CONTENT AND BRINGING THE MOST QUALITY CONTENT VALUE TO USERS
          </p>
          <div class="cards">
            <div class="card hq">
              <h3>High-quality content</h3>
              <p>
                Concentrating on delivering superior material across a diverse spectrum of categories.
              </p>
            </div>
            <div class="card enhance">
              <h3>Enhanced Viewing Experience</h3>
              <p>
                Enhancing user experience through high-definition video content across a spectrum of genres.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer id="contact">
      <div class="footer-content">
        <div class="contact">
          <div class="company" style="margin-right: 6.25rem;">
            <!-- <img src="../src/assets/logo.jpg"> -->
            <div class="logo-container">
              <img src="../src/assets/logo.jpg">
              <div>CafeDrama</div>
            </div>
            <p class="company-name">
              SHANGHAI SHAOZHEN TECHNOLOGY CO., LTD.
            </p>
          </div>
          <div class="address">
            <h4>Address</h4>
            <p>
              Building 1, No. 1, Haikun Road, Fengxian District, Shanghai
            </p>
          </div>
          <!-- <div class="qrcode">
            <h4>Public Number</h4>
            <img src="./img/img_qrcode.png">
          </div> -->
        </div>
        <p class="copyright">
          Copyright@2024 SHANGHAI SHAOZHEN TECHNOLOGY CO., LTD. All rights reserved. Shanghai ICP No. 2024057299-1
        </p>
      </div>
    </footer>
    <!-- <svg  t="1718288751040" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4235" width="200" height="200"><path d="M512 74.666667C270.933333 74.666667 74.666667 270.933333 74.666667 512S270.933333 949.333333 512 949.333333 949.333333 753.066667 949.333333 512 753.066667 74.666667 512 74.666667z m0 810.666666c-204.8 0-373.333333-168.533333-373.333333-373.333333S307.2 138.666667 512 138.666667 885.333333 307.2 885.333333 512 716.8 885.333333 512 885.333333z" fill="#000" p-id="4236"></path><path d="M533.333333 307.2c-12.8-10.666667-32-10.666667-44.8 0l-181.333333 170.666667c-12.8 12.8-12.8 32-2.133333 44.8s32 12.8 44.8 2.133333l128-119.466667v277.333334c0 17.066667 14.933333 32 32 32s32-14.933333 32-32V405.333333l128 119.466667c6.4 6.4 14.933333 8.533333 21.333333 8.533333 8.533333 0 17.066667-4.266667 23.466667-10.666666 12.8-12.8 10.666667-34.133333-2.133334-44.8l-179.2-170.666667z" fill="#ffffff" p-id="4237"></path></svg> -->
    <svg @click="handleTop" id="ic-top" class="icon icon-top" t="1734575296712" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4270" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M511.99872 0C229.23008 0 0 229.23136 0 512c0 282.76992 229.23008 512 512 512 282.7712 0 512-229.23008 512-512C1024 229.23136 794.76992 0 511.99872 0zM743.37024 604.99968c-8.61696 0-16.47744-3.49312-22.1376-9.13792L542.752 417.46176l0 414.38592c0 17.24544-13.98528 31.2448-31.24608 31.2448-17.27744 0-31.27552-14.00064-31.27552-31.2448l0-0.02944L480.2304 418.432 303.33952 595.3408c-5.7088 5.96736-13.7536 9.67552-22.67904 9.67552-17.35168 0-31.41376-14.06208-31.41376-31.4304 0-8.6144 3.49184-16.43008 9.09312-22.0928l230.90816-230.9376c5.72288-6.03136 13.76768-9.81504 22.74048-9.81504 8.8128 0 16.79872 3.67744 22.47552 9.53856L765.61408 551.4624l0 0.02944c5.64736 5.6448 9.13792 13.47712 9.13792 22.12224C774.752 590.95296 760.70656 604.99968 743.37024 604.99968zM772.9216 281.8624 251.07712 281.8624c-17.2608 0-31.27552-14.03008-31.27552-31.2768 0-17.2928 14.01472-31.27808 31.27552-31.27808l521.84576 0c17.25952 0 31.27808 13.98528 31.27808 31.27808C804.19968 267.83104 790.1824 281.8624 772.9216 281.8624z" fill="#272636" p-id="4271"></path></svg>
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, ref } from 'vue'

export default {
  name: 'App',
  setup() {
    const isShow = ref(false);
    const handleScroll = () => {
      const productsSection = document.getElementById('products');
      const icTop = document.getElementById('ic-top');
      const productsPosition = productsSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      console.log('handleScroll', productsPosition, windowHeight);
      if (productsPosition <= 0) {
        isShow.value = true;
        icTop.style.display = 'block';
      } else {
        isShow.value = false;
        icTop.style.display = 'none';
      }
    };

    const handleTop = () => {
      const appElement = document.getElementById('app-contain');
      appElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };

    const setRemUnit = () => {
      const baseSize = 16; // 基础字体大小
      const baseWidth = 1260; // 设计稿宽度
      const clientWidth = document.documentElement.clientWidth || window.innerWidth;
      const fontSize = (clientWidth / baseWidth) * baseSize;
      if (baseWidth > clientWidth) {
        document.documentElement.style.fontSize = `${fontSize}px`;
      } else {
        document.documentElement.style.fontSize = `${baseSize}px`;
      }
    };

    onMounted(() => {
      setRemUnit();
      const appElement = document.getElementById('app-contain');
      appElement.addEventListener('scroll', handleScroll);
    });

    onBeforeUnmount(() => {
      const appElement = document.getElementById('app-contain');
      appElement.removeEventListener('scroll', handleScroll);
    });

    return {
      isShow,
      handleTop
    };
  }
}
</script>

<style lang="less">
@import 'animate.css/animate.min.css';
body {
  margin: 0;
  padding: 0;
  overflow: hidden; /* 防止 body 滚动 */
  background-color: #121212; /* 深色背景 */
  color: #ffffff; /* 浅色文本 */
}
a {
  text-decoration: none;
  outline: none;
  color: #ffffff; /* 浅色链接 */
}
body, dl, dd, ul, ol, h1, h2, h3, h4, h5, h6, p, form, header, section, article, footer, div, span, img, a, button {
  margin: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: none;
}
a, select, div {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}
h1, h2, h3, h4, h5, h6 {
  font-size: 100%;
  font-weight: normal;
}
* {
  -webkit-text-size-adjust: none;
  padding: 0;
  margin: 0;
}
#app-contain {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: #121212; /* 深色背景 */
  position: relative;
}
.header-bg {
  backdrop-filter: blur(5px);
  background-color: rgba(18, 19, 26, 0.8); /* 深色背景 */
}
#header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
  backdrop-filter: blur(5px);
  background-color: rgba(18, 19, 26, 0.8); /* 深色背景 */
  .header-content {
    width: 60rem;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    padding: .5rem 0;
    .logo-container{
      display: flex;
      align-items: center;
      img {
        width: 2.125rem;
        height: 2.125rem;
      }
      div {
        color: #ffffff; /* 浅色文本 */
        font-size: 1.5rem;
        font-family: Inter;
        margin-left: .5rem;
        font-weight: 900;
      }
    }
    nav {
      margin-left: 10.3125rem;
      display: flex;
      align-items: center;
      a{
        margin-right: 2rem;
        color: #ffffff; /* 浅色链接 */
        font-size: 1rem;
        font-family: Inter;
      }
      .active{
        font-weight: bold;
        font-size: 1rem;
        font-family: Inter;
      }
    }
  }
}
.top-section {
  background-image: url(../src/assets/img_banner.jpg);
  background-size: cover;
  background-position: center;
  height: 50.625rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  div{
    margin-top: -25rem;
    width: 56.25rem;
    font-size: 4rem;
    font-weight: 900;
    color: #ffffff; /* 浅色文本 */
    text-shadow: .125rem .125rem .25rem rgba(0, 0, 0, 0.5); /* 添加字体阴影 */
  }
  .animate__backInDown{
    -webkit-animation-name: backInDown;
    animation-name: backInDown;
  }
  .animate__animated{
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
}
.bg-text{
  font-family: Montserrat, Montserrat;
  font-weight: 600;
  font-size: 6.25rem;
  color: rgba(255, 255, 255, 0.04); /* 浅色文本 */
}
main{
  background-image: url(../src/assets/img_section_bg.jpeg);
  background-size: cover;
}

section{
  width: 100%;
  height: 50.625rem;
  background-size: cover;
  font-family: Inter;
  .section-content{
    display: flex;
    width: 60rem;
    margin: 0 auto;
    align-items: center;
    flex-direction: row;
    height: 100%;
    position: relative;
  }
  .product1 {
    position: absolute;
    left: 20.125rem;
    top: 13.75rem;
  }
  .product2 {
    position: absolute;
    left: 0rem;
    top: 15.875rem;
  }
  .product3 {
    position: absolute;
    left: 20.0625rem;
    top: 15.875rem;
  }
  #product2-left{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .content-title {
      padding-left: 0;
      padding-right: 7.5rem;
      width: 28.25rem;
    }
    .content-subtitle {
      padding-left: 0;
      padding-right: 7.5rem;
      width: 28.25rem;
    }
  }
  #product3-right{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .content-title {
      padding-left: 7.5rem;
      padding-right: 0;
      width: 25.25rem;
    }
    .content-subtitle {
      padding-left: 7.5rem;
      padding-right: 0;
      width: 25.25rem;
    }
  }
  .screenshot-box{
    position: relative;
  }
  .screenshot-b{
    border-radius: 3.125rem;
    overflow: hidden;
    margin: .625rem;
  }

  .screenshot {
    height: 34.25rem;
    box-sizing: border-box;
  }
  .content-title {
    padding-left: 7.5rem;
    width: 36.875rem;
    text-align: left;
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 4rem;
    line-height: 4.6875rem;
    color: rgba(255, 255, 255, 0.9); /* 浅色文本 */
  }
  .content-subtitle {
    padding-left: 7.5rem;
    text-align: left;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 1.125rem;
    color: rgba(255, 255, 255, 0.5); /* 浅色文本 */
    margin-top: 0.15rem;
  }
}
section .section-content.about, section .section-content.mission {
  flex-direction: column;
  align-items: start;
}
section .section-content.about {
  justify-content: center;
}
.about-us {
  position: absolute;
  top: 8.125rem;
}
section .section-content.about h2 {
  font-family: 'Inter';
  font-weight: 500;
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.9); /* 浅色文本 */
  line-height: 4.8125rem;
  text-align: left;
}
.about-img {
  margin: .875rem 0;
  width: 10rem;
  height: 2rem;
  color: white;
  font-size: 3rem;
  font-weight: 500;
  background-image: url(../src/assets/img_introduction.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.introduce {
  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9); /* 浅色文本 */
  line-height: 1.625rem;
  width: 42.5rem;
  text-align: left;
}
section .section-content.about, section .section-content.mission {
  flex-direction: column;
  align-items: start;
}
section .section-content.mission {
  justify-content: center;
}
.mission-title {
    position: relative;
}
.mission-img {
  width: 6rem;
  height: 2rem;
  background-image: url(../src/assets/img_mission.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  left: .5rem;
  bottom: 1.75rem;
}
.mission-text {
  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 1.625rem;
  color: rgba(255, 255, 255, 0.9); /* 浅色文本 */
  text-align: left;
}
.cards {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 2.5rem;
}
.cards .card {
  flex-grow: 1;
  height: 5.5rem;
  margin-top: 1.25rem;
  border-radius: 1rem;
  backdrop-filter: blur(5px);
  background-color: rgba(18, 19, 26, 0.8); /* 深色背景 */
}
.cards .card.hq {
  background-image: url(../src/assets/img_premium.png);
  background-size: 3.25rem 2.75rem;
  background-repeat: no-repeat;
  background-position: 1.25rem 50%;
  padding-left: 5rem;
  padding-right: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.cards .card.enhance {
  background-image: url(../src/assets/img_hd.png);
  background-size: 3.25rem 2.75rem;
  background-repeat: no-repeat;
  background-position: 1.25rem 50%;
  padding-left: 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.card h3 {
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.9); /* 浅色文本 */
  line-height: 1.375rem;
  text-align: left;
}
.card p {
  font-weight: 400;
  font-size: .75rem;
  color: rgba(255, 255, 255, 0.74); /* 浅色文本 */
  line-height: .875rem;
  margin-top: .3125rem;
  text-align: left;
}
footer {
  background-color: rgba(17, 18, 25, 1);
  padding-bottom: 1.875rem;
}
.footer-content {
  width: 60rem;
  margin: 0 auto;
  padding-top: 5.625rem;
  font-family: Inter;
  .contact {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .company, .address {
    width: 13.75rem;
  }
  .logo-container{
    display: flex;
    align-items: center;
    img {
      width: 2.625rem;
      height: 2.625rem;
    }
    div {
      color: white;
      font-size: 1.5rem;
      font-family: Inter;
      margin-left: .5rem;
      font-weight: 900;
    }
  }
  .company .company-name {
    font-weight: 400;
    font-size: 1.25rem;
    color: white;
    margin-top: 0.2rem;
    text-align: left;
  }
  .contact h4 {
    font-size: 1.5rem;
    color: white;
    text-align: left;
  }
  .contact .address p {
    margin-top: .75rem;
    font-weight: 400;
    font-size: 1rem;
    color: white;
    text-align: left;
  }
  .copyright {
    font-weight: 400;
    font-size: .875rem;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 3.125rem;
    text-align: center;
  }
}
.icon-top {
  width: 3.125rem;
  height: 3.125rem;
  position: fixed;
  bottom: 1.875rem;
  right: 3.125rem;
  cursor: pointer;
  display: none;
}
</style>
